module.exports = __webpack_public_path__ + "img/qiqihaer.091c0fbc.jpg";